import { FC, PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Skeletons from '../../../components/Skeletons';
import { useAuth } from '../../../hooks/auth';
import { useGetCustomerByIdQuery } from '../../../services/customer/customer-service';
import * as CONSTANTS from '../../constants';

const PJRouteGuard: FC<PropsWithChildren> = () => {
  const { userInfo, authenticatedIsPending } = useAuth();
  const { data: customer, isLoading } = useGetCustomerByIdQuery(
    userInfo.customer || '',
    { skip: !userInfo.customer },
  );

  if (authenticatedIsPending || isLoading) {
    return <Skeletons.LandingPage />;
  }

  // Se for PF, redireciona para o dashboard
  if (customer?.customerType === 'PF') {
    return <Navigate to={CONSTANTS.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default PJRouteGuard;
